import { useContext, useEffect, useRef } from "react";
import translate from "../locales";
import { SocketContext } from "../websocket";
import { calculateResults } from "../calculations";

export function Result({ questionSet, answers, onRestart }) {
  const timeoutRef = useRef();
  const websocket = useContext(SocketContext);

  useEffect(() => {
    reportResults();
    reportToFathom();
    scheduleAutoclose();

    return () => clearTimeout(timeoutRef.current);
  }, []);

  function scheduleAutoclose() {
    clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => onRestart(), 60_000);
  }

  function reportResults() {
    const searchParams = new URLSearchParams(window.location.search);
    const results = calculateResults(questionSet, answers);
    websocket.send({
      action: "result",
      kiosk: searchParams.get("kiosk_id"),
      data: {
        parties: results,
      },
    });
  }

  function reportToFathom() {
    if (window.fathom) window.fathom.trackEvent("Completed flow");
  }

  return (
    <main className="content" onMouseOver={scheduleAutoclose}>
      <h1 className="content__title">{translate("result.title")}</h1>
      <p className="content__subtitle">{translate("result.subtitle")}</p>
      <button className="content__button button" onClick={onRestart}>
        {translate("result.button")}
      </button>
      <p className="content__disclaimer">{translate("general.disclaimer")}</p>
    </main>
  );
}
